<div class="dialog addToCollection">
    @if (assets) {
        <div class="dialog-title">
            <h2 mat-dialog-title>
                @if (assets.length === 1) {
                    {{ 'dialog.create.collection' | translate }}
                } @else {
                    {{ 'dialog.create.collection' | translate }}
                }
            </h2>
            <button mat-icon-button (click)="close()">
                <mat-icon  fontIcon="close"></mat-icon>
            </button>
        </div>
        <mat-dialog-content>
            @if (error) {
                <div class="row">
                    <div class="col-12 error">
                        {{ error | translate }}
                    </div>
                </div>
            }
            <form [formGroup]="addToCollectionForm">
                @if (!showAddNewCollection) {
                    <div class="row">
                        <div class="col12">
                            <h3 class="no-margin mb-3">{{'chose_existing_collection' | translate}}</h3>
                            <mat-form-field>
                                <mat-label> {{ 'collection.addasset.choosecollection' | translate }}</mat-label>
                                <input matInput [matAutocomplete]="auto" formControlName="search">
                            </mat-form-field>
                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCollection($event)" [displayWith]="displayFn" >
                                @for (coll of collections; track coll.uuid) {
                                    <mat-option [value]="coll">
                                        <span>{{coll.name}}</span>
                                    </mat-option>
                                }
                            </mat-autocomplete>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-12">
                            <h3 class="no-margin mb-3">{{'create_new_collection' | translate}}</h3>
                            <button type="button" mat-raised-button (click)="showAddNewCollectionForm()">
                                {{ 'collection.addasset.newcollection' | translate }}
                            </button>
                        </div>
                    </div>
                }
                @if (showAddNewCollection) {
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                                <mat-label>{{'collection.name'| translate}}</mat-label>
                                <input matInput formControlName="title">
                            </mat-form-field>
                           <!-- <p class="hint">Lorem ipsum</p> -->
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                                <mat-label>{{ 'collection.description' | translate }}</mat-label>
                                <input matInput formControlName="description">
                            </mat-form-field>
                        </div>
                    </div>
                }
                <div class="row">
                    <div class="col-12">
                        <div class="btn-row">
                            <button mat-button type="button" (click)="close()">{{'button.cancel'|translate}}</button>
                            <button mat-raised-button type="submit" (click)="confirm()"
                                    [disabled]="!addToCollectionForm.valid && !submitted">{{'button.save'|translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </mat-dialog-content>

    }
</div>
